import React, { ReactElement } from 'react';
interface CardHeaderProps {
  header: string;
  subHeader?: string;
}

export function CardHeader({
  header,
  subHeader,
}: CardHeaderProps): ReactElement {
  return (
    <div className="pb-3">
      <div className="text-7 pb-0.5 font-semibold">{header}</div>
      {subHeader && (
        <div className="text-3 font-normal text-gray-70">{subHeader}</div>
      )}
    </div>
  );
}
